import { useState } from 'react';
import styled from 'styled-components';
import ImminentItem from './ImminentItem';
import SampleCard from './SampleCard';
import { isLogin } from '../../../utils/auth';
const ItemAndSample = ({ imminentList, sampleList }: any) => {
  const [sampleTab, setSampleTab] = useState('auction');

  return (
    <Container>
      <Inner>
        <SalePendingWrapper>
          <div>매각 임박 물건 소개</div>
          <ImminentItemList>
            {imminentList &&
              Array.isArray(imminentList) &&
              imminentList
                .slice(0, 4)
                .map((item: any, index: any) => (
                  <ImminentItem
                    key={item.id || index}
                    item={item}
                    loginYN={isLogin()}
                  />
                ))}
          </ImminentItemList>
        </SalePendingWrapper>
        <SampleCardWrapper>
          <div>샘플 물건</div>
          <SampleTabBox>
            <SampleTabButton
              onClick={() => setSampleTab('auction')}
              isActive={sampleTab === 'auction'}
            >
              경매샘플
            </SampleTabButton>
            <SampleTabButton
              isActive={sampleTab === 'pAuction'}
              onClick={() => setSampleTab('pAuction')}
            >
              공매샘플
            </SampleTabButton>
            <SampleTabButton
              isActive={sampleTab === 'NPL'}
              onClick={() => setSampleTab('NPL')}
            >
              NPL샘플
            </SampleTabButton>
          </SampleTabBox>
          <SampleCard
            title={sampleTab}
            list={
              sampleTab === 'auction'
                ? sampleList.auction
                : sampleTab === 'pAuction'
                  ? sampleList.pAuction
                  : sampleList.npl
            }
          ></SampleCard>
        </SampleCardWrapper>
      </Inner>
    </Container>
  );
};

export default ItemAndSample;

interface ISampleProps {
  isActive: boolean;
}

const SampleTabButton = styled.div<ISampleProps>`
  display: flex;
  flex-direction: row;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  border-radius: 9999px;
  padding: 8px 16px;
  color: ${(props) => (props.isActive ? '#fff' : '#989ba2')};
  background: ${(props) =>
    props.isActive ? '#222' : 'rgba(112, 115, 124, 0.08)'};
`;

const SampleTabBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const SampleCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ImminentItemList = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
`;

const SalePendingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;

  width: 100%;
  height: 100%;
  padding: 32px 16px;
  padding-bottom: 72px;

  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;

const Container = styled.div`
  width: 100%;
  // height: 1205px;
  // background-color: #f7f8fc;
`;
